import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import LinkButton from './LinkButton';

const DocumentsTableFooter = ({ selectedCount, onUnselectAll, onDownload }) => (
  <Box
    style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#fff',
      borderTop: '1px solid #e0e0e0',
      padding: '16px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '16px',
      zIndex: 1201,
      // Added box shadow here
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    }}
  >
    <Typography variant="body1">
      {selectedCount} {selectedCount === 1 ? 'Document' : 'Documents'} Selected
    </Typography>
    <LinkButton
      color="secondary"
      onClick={onUnselectAll}
      variant="text"
      size="large"
      style={{ fontSize: '15px' }}
    >
      Unselect All
    </LinkButton>
    <LinkButton
      color="secondary"
      onClick={onDownload}
      variant="text"
      size="large"
      style={{ fontSize: '17px', marginLeft: '48px' }}
    >
      Download
      <DownloadIcon style={{ marginLeft: '8px' }} />
    </LinkButton>
  </Box>
);

DocumentsTableFooter.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  onUnselectAll: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
};

export default DocumentsTableFooter;
